module.exports = __webpack_public_path__ + "img/ice_claws_small.8fbf2fcb.png";